var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tis-button',{staticClass:"btn-inverted text-sm tracking-wide rounded-sm py-5 px-8 ml-4",attrs:{"url":_vm.url,"full-redirect":_vm.fullRedirect,"target":_vm.target,"title":_vm.title}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }